/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AutoChatReplySettingExtraType =
  | 'BOOKING_REQUEST'
  | 'NONE'
  | 'QUESTION';

export type AutoChatReplySettingInputExtra = {
  bookingRequest?: AutoChatReplySettingInputExtraBookingRequest | null | undefined;
  /** 次のプロパティは extraType に対応した値が Non-null になっている */
  question?: AutoChatReplySettingInputExtraQuestion | null | undefined;
  type: AutoChatReplySettingExtraType;
};

export type AutoChatReplySettingInputExtraBookingRequest = {
  assignedCalendarGuid?: string | number | null | undefined;
  availableTimeSlotRange: ExtraBookingRequestAvailableTimeSlotRange;
  fallbackUrl?: string | null | undefined;
};

export type AutoChatReplySettingInputExtraQuestion = {
  selections: Array<string>;
};

export type CreateAutoChatReplySettingInput = {
  body: string;
  extra: AutoChatReplySettingInputExtra;
  isEnabled: boolean;
  keyword: string;
};

export type ExtraBookingRequestAvailableTimeSlotRange =
  | 'ANYTIME'
  | 'WEEKDAY_ANYTIME'
  | 'WEEKDAY_DAYTIME'
  | 'WEEKDAY_NIGHT'
  | 'WEEKEND_ANYTIME'
  | 'WEEKEND_DAYTIME'
  | 'WEEKEND_NIGHT';

export type CreateAutoChatReplySettingMutationVariables = Exact<{
  input: Types.CreateAutoChatReplySettingInput;
}>;


export type CreateAutoChatReplySettingMutation = { createAutoChatReplySetting:
    | { __typename: 'AutoChatReplySettingDuplicateKeywordError' }
    | { __typename: 'SaveAutoChatReplySettingSuccess', autoChatReplySetting: { id: string, body: string, keyword: string, isEnabled: boolean, extra: { type: Types.AutoChatReplySettingExtraType } } }
   };


export const CreateAutoChatReplySettingDocument = gql`
    mutation createAutoChatReplySetting($input: CreateAutoChatReplySettingInput!) {
  createAutoChatReplySetting(input: $input) {
    __typename
    ... on SaveAutoChatReplySettingSuccess {
      autoChatReplySetting {
        id
        body
        keyword
        isEnabled
        extra {
          type
        }
      }
    }
    ... on AutoChatReplySettingDuplicateKeywordError {
      __typename
    }
  }
}
    `;

/**
 * __useCreateAutoChatReplySettingMutation__
 *
 * To run a mutation, you first call `useCreateAutoChatReplySettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoChatReplySettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAutoChatReplySettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutoChatReplySettingMutation(options: VueApolloComposable.UseMutationOptions<CreateAutoChatReplySettingMutation, CreateAutoChatReplySettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAutoChatReplySettingMutation, CreateAutoChatReplySettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAutoChatReplySettingMutation, CreateAutoChatReplySettingMutationVariables>(CreateAutoChatReplySettingDocument, options);
}
export type CreateAutoChatReplySettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAutoChatReplySettingMutation, CreateAutoChatReplySettingMutationVariables>;